/**
 * Vita Qualitat - Custom Fixes
 * Este archivo contiene las correcciones para las funcionalidades del tema
 */

// Fallback para trapFocus / removeTrapFocus si el tema no los define
if (typeof window.trapFocus !== 'function') {
  window.trapFocus = function (container, elementToFocus) {
    try {
      (elementToFocus || container)?.focus?.();
    } catch (e) {
      console.warn('[menu-log] trapFocus fallback error', e);
    }
  };
  console.info('[menu-log] trapFocus fallback instalado');
}

if (typeof window.removeTrapFocus !== 'function') {
  window.removeTrapFocus = function () {
    // No-op: fallback para evitar errores JS
  };
  console.info('[menu-log] removeTrapFocus fallback instalado');
}

// FIX 1: Corregir selectores de cantidad (+/-) en página de producto y carrito
if (!customElements.get('quantity-input')) {
  customElements.define('quantity-input', class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');
      this.changeEvent = new Event('change', { bubbles: true });
      this.input.addEventListener('change', this.onInputChange.bind(this));

      this.querySelectorAll('button').forEach((button) =>
        button.addEventListener('click', this.onButtonClick.bind(this))
      );
    }

    quantityUpdateUnsubscriber = undefined;

    connectedCallback() {
      this.validateQtyRules();
      this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
    }

    disconnectedCallback() {
      if (this.quantityUpdateUnsubscriber) {
        this.quantityUpdateUnsubscriber();
      }
    }

    onInputChange() {
      this.validateQtyRules();
    }

    onButtonClick(event) {
      event.preventDefault();
      const previousValue = this.input.value;
      const button = event.currentTarget;

      if (button.name === 'plus') {
        this.input.stepUp();
      } else {
        this.input.stepDown();
      }

      if (previousValue !== this.input.value) {
        this.input.dispatchEvent(this.changeEvent);
      }

      // Trigger update for cart items
      if (this.input.dataset.index) {
        this.updateCartQuantity();
      }
    }

    validateQtyRules() {
      const value = parseInt(this.input.value);
      const min = parseInt(this.input.min) || 0;
      const max = parseInt(this.input.max);
      const step = parseInt(this.input.step) || 1;

      let valueIsAvailable = true;

      if (!isNaN(max) && value > max) {
        this.input.value = max;
        valueIsAvailable = false;
      } else if (value < min) {
        this.input.value = min;
        valueIsAvailable = false;
      } else if (value % step !== 0) {
        this.input.value = Math.floor(value / step) * step;
        valueIsAvailable = false;
      }

      if (!valueIsAvailable) {
        this.input.dispatchEvent(this.changeEvent);
      }
    }

    updateCartQuantity() {
      if (this.input.dataset.index && this.input.dataset.index !== '') {
        // Actualizar el carrito mediante AJAX
        this.updateCart();
      }
    }

    updateCart() {
      const cartDrawer = document.querySelector('cart-drawer');
      const isCartPage = window.location.pathname.includes('/cart');

      // Deshabilitar botones mientras se procesa
      this.querySelectorAll('button').forEach(btn => btn.disabled = true);

      const formData = {
        line: this.input.dataset.index,
        quantity: this.input.value
      };

      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      })
      .then((response) => {
        return response.json();
      })
      .then((state) => {
        console.log('Cart updated successfully:', state);

        // Si estamos en la página del carrito, recargamos la página completa
        if (isCartPage) {
          window.location.reload();
        }
        // Si estamos en el cart drawer
        else if (cartDrawer) {
          if (typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(state);
          } else {
            // Fallback: recargar secciones del cart drawer
            this.refreshCartDrawer(state);
          }
        }

        // Re-habilitar botones
        this.querySelectorAll('button').forEach(btn => btn.disabled = false);

        // Publicar evento de actualización
        publish(PUB_SUB_EVENTS.cartUpdate, {source: 'quantity-update', cartData: state});
      })
      .catch((error) => {
        console.error('Error actualizando carrito:', error);

        // Re-habilitar botones en caso de error
        this.querySelectorAll('button').forEach(btn => btn.disabled = false);

        // Mostrar mensaje de error
        alert('Error al actualizar el carrito. Por favor, intenta de nuevo.');
      });
    }

    refreshCartDrawer(cart) {
      const cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer) return;

      // Obtener la sección actualizada del cart drawer
      fetch(window.Shopify.routes.root + 'cart?sections=cart-drawer')
        .then((response) => response.json())
        .then((sections) => {
          if (sections['cart-drawer']) {
            const html = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
            const newCartDrawer = html.querySelector('.cart-drawer');

            if (newCartDrawer) {
              const currentCartDrawer = document.querySelector('.cart-drawer');
              if (currentCartDrawer) {
                currentCartDrawer.innerHTML = newCartDrawer.innerHTML;
              }
            }
          }

          // Actualizar contador del carrito
          this.updateCartCount(cart.item_count);
        })
        .catch((error) => {
          console.error('Error refrescando cart drawer:', error);
        });
    }

    updateCartCount(count) {
      const cartCountBubble = document.querySelector('.cart-count-bubble');
      if (cartCountBubble) {
        cartCountBubble.textContent = count;
        if (count > 0) {
          cartCountBubble.classList.remove('hidden');
        } else {
          cartCountBubble.classList.add('hidden');
        }
      }
    }
  });
}

// Definir el evento de suscripción si no existe
const PUB_SUB_EVENTS = window.PUB_SUB_EVENTS || {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change'
};

// Pub/Sub simple implementation
const subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }
  subscribers[eventName].push(callback);
  return () => {
    subscribers[eventName] = subscribers[eventName].filter((cb) => cb !== callback);
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => callback(data));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  // Publicar evento cuando cambie un quantity-input
  document.querySelectorAll('quantity-input input').forEach((input) => {
    input.addEventListener('change', () => {
      publish(PUB_SUB_EVENTS.quantityUpdate, { source: 'quantity-input-change' });
    });
  });
});

// Logs para depurar la apertura/cierre del menú hamburguesa
(function setupMenuDrawerLogs() {
  const MenuDrawerClass = customElements.get('menu-drawer');
  if (!MenuDrawerClass) return;
  if (MenuDrawerClass.prototype.__vitaMenuLogsApplied) return;
  MenuDrawerClass.prototype.__vitaMenuLogsApplied = true;

  const logState = (instance, label) => {
    try {
      const details = instance?.querySelector('details');
      const summary = details?.querySelector('summary');
      console.log('[menu-log]', label, {
        detailsOpen: details?.hasAttribute('open'),
        ariaExpanded: summary?.getAttribute('aria-expanded'),
        menuOpening: details?.classList.contains('menu-opening'),
        bodyClasses: document.body.className,
      });
    } catch (err) {
      console.warn('[menu-log] error logging state', err);
    }
  };

  const wrapMethod = (methodName) => {
    const original = MenuDrawerClass.prototype[methodName];
    if (typeof original !== 'function') return;
    MenuDrawerClass.prototype[methodName] = function wrappedMenuMethod(...args) {
      logState(this, `${methodName} (start)`);
      const result = original.apply(this, args);
      // Registrar el estado después de que el método termine/asíncrono
      setTimeout(() => logState(this, `${methodName} (end)`), 0);
      return result;
    };
  };

  ['onSummaryClick', 'openMenuDrawer', 'closeMenuDrawer', 'closeSubmenu'].forEach(wrapMethod);

  document.addEventListener('DOMContentLoaded', () => {
    const headerDrawer = document.querySelector('header-drawer');
    const details = headerDrawer?.querySelector('details');
    const summary = details?.querySelector('summary');
    const closeBtn = headerDrawer?.querySelector('.menu-drawer__close-menu-btn');

    summary?.addEventListener('click', () => logState(headerDrawer, 'summary click'));
    details?.addEventListener('toggle', () => logState(headerDrawer, 'details toggle'));
    closeBtn?.addEventListener('click', () => logState(headerDrawer, 'close button click'));
  });
})();

// Sincronización de miniaturas (copiado de tail original)
document.addEventListener('DOMContentLoaded', () => {
  const mediaGallery = document.querySelector('media-gallery, product-media-gallery');
  if (!mediaGallery) return;

  const thumbnails = mediaGallery.querySelectorAll('[data-target]');
  thumbnails.forEach((thumbnail) => {
    const button = thumbnail.querySelector('button');
    if (button) {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        const mediaId = thumbnail.dataset.target;

        // Encontrar el media correspondiente
        const targetMedia = mediaGallery.querySelector(`[data-media-id="${mediaId}"]`);

        if (targetMedia) {
          // Remover clase activa de todos los medios
          mediaGallery.querySelectorAll('[data-media-id]').forEach((media) => {
            media.classList.remove('is-active');
          });

          // Agregar clase activa al media seleccionado
          targetMedia.classList.add('is-active');

          // Scroll al media seleccionado
          targetMedia.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

          // Actualizar thumbnail activo
          thumbnails.forEach((thumb) => {
            thumb.querySelector('button').removeAttribute('aria-current');
          });
          button.setAttribute('aria-current', 'true');
        }
      });
    }
  });

  // También agregar soporte para click directo en las miniaturas (para móvil)
  const mediaItems = mediaGallery.querySelectorAll('[data-media-id]');
  mediaItems.forEach((media) => {
    media.addEventListener('click', function (e) {
      if (window.innerWidth <= 750) { // Solo en móvil
        e.preventDefault();

        // Remover clase activa de todos
        mediaItems.forEach((m) => m.classList.remove('is-active'));

        // Activar el clickeado
        media.classList.add('is-active');

        // Actualizar thumbnails
        const mediaId = media.dataset.mediaId;
        const correspondingThumbnail = mediaGallery.querySelector(`[data-target="${mediaId}"]`);
        if (correspondingThumbnail) {
          thumbnails.forEach((thumb) => {
            thumb.querySelector('button').removeAttribute('aria-current');
          });
          correspondingThumbnail.querySelector('button').setAttribute('aria-current', 'true');
        }
      }
    });
  });
});

console.log('Vita Qualitat custom fixes loaded successfully');
